import React from "react";
import { generatePostImageUrl } from "utility";
import { Orientation } from "utility/constants";
import Image from "next/image";

export default function ImagePost({ post }) {
  // Portraint images
  if (
    post.contentOrientation === Orientation.PORTRAIT ||
    post.contentOrientation === Orientation.PORTRAIT_UPSIDE_DOWN
  ) {
    const postUrl = generatePostImageUrl({
      post,
      edits: {
        resize: { fit: "cover", strategy: "attention" },
      },
    });
    return (
      <Image
        height={1000}
        width={1000}
        quality={100}
        src={`${postUrl}`}
        className="object-cover h-screen max-w-full w-full md:w-auto lg:mx-auto overflow-hidden"
        alt=""
      />
    );
  }

  // Landscape images
  const imageRotation = {
    [Orientation.LANDSCAPE_LEFT]: 90,
    [Orientation.LANDSCAPE_RIGHT]: -90,
  };

  const rotate = imageRotation[post.contentOrientation];
  const postUrl = generatePostImageUrl({
    post,
    edits: {
      ...(rotate ? { rotate } : undefined),
      resize: { width: 340, fit: "cover", strategy: "attention" },
    },
  });

  return (
    <Image
      height={1000}
      width={1000}
      quality={100}
      className="object-cover h-screen max-w-full w-full md:w-auto lg:mx-auto overflow-hidden"
      src={postUrl}
      alt={post?.title}
    />
  );
}
